import { Component, OnInit , ViewChild} from '@angular/core';
import { ChartType, ChartOptions, ChartDataSets } from 'chart.js';
import { MultiDataSet,SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip , Color} from 'ng2-charts';
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import {formatDate} from '@angular/common';
import { MainServiceService } from "src/app/services/main-service.service";
import { BaseChartDirective } from 'ng2-charts';
import { SpinnerService } from '../_services/spinner.service';
import { AlertService } from '../_services/alert.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  period = '';
  dateFormat:any = 'AD';
  periodIntervals = ['Today','This week','This month','Last 7 days','Last 30 days','DateRange'];
  FromDate:any;
  ToDate:any;
  FromDateBS:string;
  ToDateBS:string;
  storedata: any;
  @ViewChild(BaseChartDirective) public chart: BaseChartDirective;
  @ViewChild("ownerFranchise") public ownerfranchisechart: BaseChartDirective;
  @ViewChild("stateWiseSales") public statewisechart: BaseChartDirective;
  @ViewChild("storeWiseSales") public storewisechart: BaseChartDirective;
  @ViewChild("categoryTop") public categorytopchart: BaseChartDirective;
  @ViewChild("categoryWorst") public categoryworstchart: BaseChartDirective;
  @ViewChild("itemWiseTop") public itemtopchart: BaseChartDirective;
  @ViewChild("itemWiseWorst") public itemworstchart: BaseChartDirective;



  finalresult:any;
  storeWiseSalesList:any[] = [];
  totalsales:number;
  totalbill:number;
  unitsold:number;
  avgBasketVal:number;
  avgSkuVal:number;
  //for totalsales owner/franchise doughnut chart
  public ownerFranchiseLabels: Label[] = [] ;
  public ownerFranchiseData: SingleDataSet = [] ;
  public ownerFranchiseType: ChartType = 'pie';
  public ownerFranchiseOptions: ChartOptions = {responsive: true, };
  public ownerFranchiseLegend = true;
  public ownerFranchisePlugins = [];

  //for top sales category wise
  public topsalesCategoryLabels: Label[] = [] ;
  public topsalesCategoryData: SingleDataSet = [] ;
  public topsalesCategoryType: ChartType = 'pie';
  public topsalesCategoryLegend = true;
  public topsalesCategoryOptions: ChartOptions = {responsive: true, };
  public topsalesCategoryPlugins = [];

  //for worse sales category wise
  public worsesalesCategoryLabels: Label[] = [] ;
  public worsesalesCategoryData: SingleDataSet= [] ;
  public worsesalesCategoryType: ChartType = 'pie';
  public worsesalesCategoryLegend = true;
  public worsesalesCategoryOptions: ChartOptions = {  responsive: true, };
  public worsesalesCategoryPlugins = [];

  //for top sales item wise
  public topSalesItemLabels: Label[] = [];
  public topSalesItemData: SingleDataSet= [] ;
  public topSalesItemType: ChartType = 'pie';
  public topSalesItemLegend = true;
  public topSalesItemOptions: ChartOptions = {
    responsive: true,
  };
  public topSalesItemPlugins = [];

  //for worse sales item wise
  public worseSalesItemLabels: Label[] = [] ;
  public worseSalesItemData: SingleDataSet = [];
  public worseSalesItemType: ChartType = 'pie';
  public worseSalesItemLegend = true;
  public worseSalesItemOptions: ChartOptions = {
    responsive: true,
  };
  public worseSalesItemPlugins = [];

  //for Store wise sales
  public StoreWiseLabels: Label[] = [];
  public StoreWiseData: SingleDataSet = [];
  public StoreWiseColor: Color[]=[{
    backgroundColor: 'skyblue'
  }]
  public StoreWiseType: ChartType = 'horizontalBar';
  public StoreWiseLegend = false;
  public StoreWiseOptions: ChartOptions = {responsive:true};
  

 
 //for state wise sales
 public StateWiseLabels: Label[] = [] ;
  public StateWiseData: SingleDataSet= [];
  public StateWiseColor: Color[] = [{
    backgroundColor: 'skyblue'
  }]
  public StateWiseType: ChartType = 'bar';
  public StateWiseLegend = false;
  public StateWiseOptions: ChartOptions = {responsive:true};

  currentDate: Date;
  formattedDate: string;
  sunday: string;
  saturday: string;
  monthstart: string;
  monthend: string;
  year: number;
  start:Date;
  end:Date;
  lastWeek: string;
  lastMonth: string;
  

  constructor(
    private http: HttpClient,
    private masterService: MainServiceService,
    private spinner:SpinnerService,
    private alert:AlertService)
    {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
    this.ownerFranchiseData = [];
  }

  ngOnInit():void {
   
            
        
    this.currentDate = new Date();
    this.formattedDate = formatDate(this.currentDate,'yyyy-MM-dd','en-US');
    console.log("@current date", this.currentDate, this.formattedDate);
    let weekstart = this.currentDate.getDate()-this.currentDate.getDay();
    let weekend = weekstart+6;
    let sunday = new Date(this.currentDate.setDate(weekstart));
    let saturday = new Date(this.currentDate.setDate(weekend));
    this.sunday = formatDate(sunday,'yyyy-MM-dd','en-US');
    this.saturday = formatDate(saturday,'yyyy-MM-dd','en-US');
    console.log("@sunday",this.sunday,"@@saturday",this.saturday);
    let monthstart = new Date(this.currentDate.getFullYear(),this.currentDate.getMonth(),1);
    console.log("monthstart",monthstart);
    let monthend = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth()+1,0);
    this.monthstart = formatDate(monthstart,'yyyy-MM-dd','en-US');
    this.monthend = formatDate(monthend,'yyyy-MM-dd','en-US');
    console.log("@@month",this.monthstart, this.monthend);

    //for past 7 days 
    let currDate = new Date();
    let pastWeekDate = currDate.getDate()-7;
    currDate.setDate(pastWeekDate);
    this.lastWeek = formatDate(currDate,'yyyy-MM-dd','en-US');
    console.log("last 7 days", this.lastWeek)

    //for past 30 days
    let newDate = new Date();
    let pastMonthDate = newDate.getDate()-30;
    newDate.setDate(pastMonthDate);
    this.lastMonth = formatDate(newDate,'yyyy-MM-dd','en-US');
console.log("last 30 days", this.lastMonth);
    
  }


  run(){
    this.spinner.show("Loading data, Please wait");
    console.log("@@date", this.FromDate,this.ToDate);
    this.masterService.masterGetMethod("/DashBoard/GetDashBoardSales?Date1="+this.FromDate+"&Date2="+this.ToDate).subscribe((res:any)=>{
     if(res.status == "ok") {
      this.finalresult=res;
      this.storeWiseSalesList = res.result.storeWiseSales;
      console.log("final result", this.finalresult);
      console.log("Store wise sales", this.storeWiseSalesList);
      this.getData();

      setTimeout(()=>{
        this.spinner.hide();
      },1000);
    // this.chart.ngOnChanges({});
    this.updateCharts();

    }else{
      console.log(res.message);
      this.spinner.hide();
      this.alert.error("Error Loading Data.");
    }
    },
    err=>{
      console.log(err.message);
      this.spinner.hide();
      this.alert.error(err);

    },
    ()=>{
      console.log('completed');
      return;
    });
      
} 



    getData(){
          let x = this.finalresult.result;
        //for dashboard summary
        this.totalsales = this.finalresult.result.dashboardSalesSummary[0].TotalSales;
        this.totalbill = this.finalresult.result.dashboardSalesSummary[0].TotalBills;
        this.unitsold = this.finalresult.result.dashboardSalesSummary[0].UnitSold;
        this.avgBasketVal = this.finalresult.result.dashboardSalesSummary[0].AvgBasketVal;
        this.avgSkuVal = this.finalresult.result.dashboardSalesSummary[0].AvgSkuVal;

        //for ownedvsfranchise
        for(let i=0; i<x.ownedVsFranchiseSales.length;i++){
          this.ownerFranchiseLabels[i] = this.finalresult.result.ownedVsFranchiseSales[i].OwnedFranchise;
          this.ownerFranchiseData[i] = this.finalresult.result.ownedVsFranchiseSales[i].TotalSales;
        }
        
        //for state wise
        for(let i=0; i<x.stateWiseSales.length;i++){
          this.StateWiseLabels[i] = x.stateWiseSales[i].State;
          this.StateWiseData[i] = x.stateWiseSales[i].TotalSales;
        }
        //for  store wise
        for(let i=0; i<x.storeWiseSales.length;i++){
          this.StoreWiseLabels[i] = x.storeWiseSales[i].StoreName;
          this.StoreWiseData[i] = x.storeWiseSales[i].TotalSales;
        }

        //for category top
        for(let i=0; i<x.categoryWiseTopSales.length;i++){
          this.topsalesCategoryLabels[i] = x.categoryWiseTopSales[i].Category;
          this.topsalesCategoryData[i] = x.categoryWiseTopSales[i].TotalSales;
        }

        //for category worst
        for(let i=0; i<x.categoryWiseWorstSales.length;i++){
          this.worsesalesCategoryLabels[i] = x.categoryWiseWorstSales[i].Category;
          this.worsesalesCategoryData[i] = x.categoryWiseWorstSales[i].TotalSales;
        }

        //for item wise top
        for(let i=0; i<x.itemWiseTopSales.length;i++){
          this.topSalesItemLabels[i] = x.itemWiseTopSales[i].Item;
          this.topSalesItemData[i] = x.itemWiseTopSales[i].TotalSales;
        }
        //for item wise worst
        for(let i=0; i<x.itemWiseWorstSales.length;i++){
          this.worseSalesItemLabels[i] = x.itemWiseWorstSales[i].Item;
          this.worseSalesItemData[i] = x.itemWiseWorstSales[i].TotalSales;
        }

    
    }

 onChange(){
  //   console.log("@@period",this.period);
  
    if(this.period == 'Today'){
  this.spinner.show("Loading data, Please wait");

      this.masterService.masterGetMethod("/DashBoard/GetDashBoardSales?Date1="+this.formattedDate+"&Date2="+this.formattedDate).subscribe((res:any)=>{
        if(res.status == "ok") {
         this.finalresult=res;
         this.storeWiseSalesList = res.result.storeWiseSales;
         console.log("final result", this.finalresult);
         console.log("Store wise sales", this.storeWiseSalesList);
         this.getData();

         setTimeout(()=>{
          this.spinner.hide();
        },1000);
    this.updateCharts();


       }else{
         console.log(res.message);
         this.spinner.hide();
      this.alert.error("Error Loading Data.");


       }
       },
       err=>{
         console.log(err.message);
         this.spinner.hide();
      this.alert.error(err);


       },
       ()=>{
         console.log('completed');
         return;
       });
    
    }
    else if(this.period == 'This week'){
  this.spinner.show("Loading data, Please wait");

      this.masterService.masterGetMethod("/DashBoard/GetDashBoardSales?Date1="+this.sunday+"&Date2="+this.saturday).subscribe((res:any)=>{
        if(res.status == "ok") {
         this.finalresult=res;
         this.storeWiseSalesList = res.result.storeWiseSales;
         console.log("final result", this.finalresult);
         console.log("Store wise sales", this.storeWiseSalesList);
         this.getData();

         setTimeout(()=>{
          this.spinner.hide();
         },1000);
    this.updateCharts();

        //  this.chart.ngOnChanges({});


       }else{
         console.log(res.message);
         this.spinner.hide();
         this.alert.error("Error Loading Data.");

       }
       },
       err=>{
         console.log(err.message);
         this.spinner.hide();
         this.alert.error(err);

       },
       ()=>{
         console.log('completed');
         return;
       });
    
    }
    else if(this.period == 'This month'){
  this.spinner.show("Loading data, Please wait");

      this.masterService.masterGetMethod("/DashBoard/GetDashBoardSales?Date1="+this.monthstart+"&Date2="+this.monthend).subscribe((res:any)=>{
        if(res.status == "ok") {
         this.finalresult=res;
         this.storeWiseSalesList = res.result.storeWiseSales;
         console.log("final result", this.finalresult);
         console.log("Store wise sales", this.storeWiseSalesList);
         this.getData();

         setTimeout(()=>{
          this.spinner.hide();
        },1000);
    this.updateCharts();


       }else{
         console.log(res.message);
         this.spinner.hide();
         this.alert.error("Error Loading Data.");

       }
       },
       err=>{
         console.log(err.message);
         this.spinner.hide();
         this.alert.error(err);

       },
       ()=>{
         console.log('completed');
         return;
       });

   
    }else if(this.period == 'Last 7 days'){
  this.spinner.show("Loading data, Please wait");

      this.masterService.masterGetMethod("/DashBoard/GetDashBoardSales?Date1="+this.lastWeek+"&Date2="+this.formattedDate).subscribe((res:any)=>{
        if(res.status == "ok") {
         this.finalresult=res;
         this.storeWiseSalesList = res.result.storeWiseSales;
         console.log("final result", this.finalresult);
         console.log("Store wise sales", this.storeWiseSalesList);
         this.getData();

        //  this.chart.ngOnChanges({});
         
         setTimeout(()=>{
           this.spinner.hide();
         })
        this.updateCharts();


       }else{
         console.log(res.message);
         this.spinner.hide();
         this.alert.error("Error Loading Data.");

       }
       },
       err=>{
         console.log(err.message);
         this.spinner.hide();
         this.alert.error(err);

       },
       ()=>{
         console.log('completed');
         return;
       });
    }else if(this.period == 'Last 30 days'){
  this.spinner.show("Loading data, Please wait");
      this.masterService.masterGetMethod("/DashBoard/GetDashBoardSales?Date1="+this.lastMonth+"&Date2="+this.formattedDate).subscribe((res:any)=>{
        if(res.status == "ok") {
         this.finalresult=res;
         this.storeWiseSalesList = res.result.storeWiseSales;
         console.log("final result", this.finalresult);
         console.log("Store wise sales", this.storeWiseSalesList);
         this.getData();
        //  this.chart.ngOnChanges({});

          setTimeout(()=>{
            this.spinner.hide();
          })
        this.updateCharts();

       }else{
         console.log(res.message);
         this.spinner.hide();
         this.alert.error("Error Loading Data.");

       }
       },
       err=>{
         console.log(err.message);
         this.spinner.hide();
         this.alert.error(err);

       },
       ()=>{
         console.log('completed');
         return;
       });
    }
  //   else{
  //     this.barChartData =[{ data: [65, 59, 80, 81, 56, 55, 40], label: 'total sales' }];
  //     this.EcomStoresData = [6000,2500];
  //     this.ownerFranchiseData = [30,70];
  //     this.topsalesCategoryData = [50,150,120];
  //     this.worsesalesCategoryData =[30,90,120];
  //     this.topSalesItemData = [300,150,90];
  //     this.worseSalesItemData = [10,65,45];
  //   }
  }

  updateCharts(){
    this.ownerfranchisechart.chart.update();
    this.statewisechart.chart.update();
    this.storewisechart.chart.update();
    this.categorytopchart.chart.update();
    this.categoryworstchart.chart.update();
    this.itemtopchart.chart.update();
    this.itemworstchart.chart.update();
return;
  }

  changeFromDate(value, format:string){
    console.log("date to change", value )
    var adbs = require("ad-bs-converter");
    if(format == "AD"){
      var adDate = (value.replace("-","/")).replace("-","/");
      var bsDate = adbs.ad2bs(adDate);
      // console.log("bs date", bsDate);
      this.FromDateBS= bsDate.en.year + '-' + bsDate.en.month + '-' + (bsDate.en.day == '1' || bsDate.en.day == '2' || bsDate.en.day == '3' || bsDate.en.day == '4' || bsDate.en.day == '5' || bsDate.en.day == '6' || bsDate.en.day == '7' || bsDate.en.day == '8' || bsDate.en.day == '9' ? '0' + bsDate.en.day : bsDate.en.day);

    }else if(format == "BS"){
      var bsDate = (value.replace("-","/")).replace("-","/");
      var adDate = adbs.bs2ad(bsDate);
      // console.log("ad date",adDate);
      this.FromDate = (adDate.year + '-' + ((adDate.month).toString().length == 1 ? '0' + adDate.month : adDate.month) + '-' + ((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
      console.log("from date changed from bs", this.FromDate);
    }
  }

  changeToDate(value, format:string){
    var adbs = require("ad-bs-converter");
    if(format == "AD"){
      var adDate = (value.replace("-","/")).replace("-","/");
      var bsDate = adbs.ad2bs(adDate);
      console.log("bs date", bsDate);
      this.ToDateBS= bsDate.en.year + '-' + bsDate.en.month + '-' + (bsDate.en.day == '1' || bsDate.en.day == '2' || bsDate.en.day == '3' || bsDate.en.day == '4' || bsDate.en.day == '5' || bsDate.en.day == '6' || bsDate.en.day == '7' || bsDate.en.day == '8' || bsDate.en.day == '9' ? '0' + bsDate.en.day : bsDate.en.day);

    }else if(format == "BS"){
      var bsDate = (value.replace("-","/")).replace("-","/");
      var adDate = adbs.bs2ad(bsDate);
      // console.log("ad date",adDate);
      this.ToDate = (adDate.year + '-' + ((adDate.month).toString().length == 1 ? '0' + adDate.month : adDate.month) + '-' + ((adDate.day).toString().length == 1 ? '0' + adDate.day : adDate.day));
      console.log("from date changed from bs", this.FromDate);
    }
  }

  



}
